import { AuthHeader } from "../../components/layout/AuthHeader";
import { createFileRoute, Outlet } from "@tanstack/react-router";

const AuthLayout = (): JSX.Element => {
	return (
		<>
			<AuthHeader />
			<main className="min-h-[calc(100vh-165px)] flex flex-col bg-muted/55 justify-between">
				<Outlet />
			</main>
		</>
	);
};

export const Route = createFileRoute("/(auth)/_auth")({
	component: AuthLayout,
});
